/*Copyright (c) 2025 por Tecnologías de Información MALMUR y empresas afiliadas. Todos los derechos reservados.
Este software es información confidencial y propietaria de Copyright (c) 2025 por Tecnologías de Información MALMUR
 y sus afiliadas. ("Información Confidencial"). Usted no puede divulgar dicha Información Confidencial, 
 y solo puede usar dicha Información Confidencial de acuerdo con los términos del acuerdo de licencia que celebró con MALMUR.*/

/*Copyright (c) 2025 by Tecnologías de Información MALMUR and affiliated companies. All Rights Reserved.
This software is confidential and proprietary information of Copyright (c) 2025 by Tecnologías de Información 
MALMUR and its affiliates. ("Confidential Information"). You may not disclose such Confidential Information, 
and may only use such Confidential Information in accordance with the terms of the license agreement you entered 
into with MALMUR.*/


import { t } from "i18next";


import { RoutesConstants } from "@malmur-technologies/medicalsystem-shared";

/**
 * Maps route constants to localized display names for navigation breadcrumbs and titles.
 * Uses i18next translation function for multi-language support.
 * @returns Record mapping RoutesConstants to translated display names
 */
export const getRouteDisplayNames = (): Record<RoutesConstants, string> => ({
    [RoutesConstants.DASHBOARD]: t('routes.dashboard'),
    [RoutesConstants.ACTIVITY_LOGS]: t('routes.activityLogs'),
    [RoutesConstants.APPOINTMENTS]: t('routes.appointments'),
    [RoutesConstants.PATIENTS]: t('routes.patients'),
    [RoutesConstants.DOCTORS]: t('routes.doctors'),
    [RoutesConstants.NURSES]: t('routes.nurses'),
    [RoutesConstants.PATIENT_HUB]: t('routes.patientHub'),
    
    [RoutesConstants.OFFICE_VISIT]: t('routes.officeVisit'),
    [RoutesConstants.PROGRESS_NOTE]: t('routes.progressNote'),
    [RoutesConstants.VITALS]: t('routes.vitals'),
    [RoutesConstants.PRESCRIPTION]: t('routes.prescription'),
    
    [RoutesConstants.TEMPLATES]: t('routes.templates'),
    [RoutesConstants.INSURANCE]: t('routes.insurance'),
    [RoutesConstants.PHARMACY]: t('routes.pharmacy'),
    [RoutesConstants.FACILITY]: t('routes.facility'),
    [RoutesConstants.RESOURCE]: t('routes.resource'),
    [RoutesConstants.PAYER]: t('routes.payer'),
    [RoutesConstants.PRICING]: t('routes.pricing'),
    
    [RoutesConstants.ACCOUNTING]: t('routes.accounting'),
    [RoutesConstants.BILLING_ENCOUNTER]: t('routes.billingEncounters'),
    [RoutesConstants.PAYMENT]: t('routes.payment'),
    [RoutesConstants.ELECTRONIC_TRANSACTION]: t('routes.electronicTransaction'),
    [RoutesConstants.INSURANCE_TRANSACTION]: t('routes.insuranceTransaction'),
    [RoutesConstants.ACCOUNTING_MOVEMENTS]: t('routes.accountingMovements'),
    
    [RoutesConstants.USER_PROFILE]: t('routes.userProfile'),
    [RoutesConstants.USER]: t('routes.userManagement'),
    [RoutesConstants.LOGIN]: t('routes.login'),
    [RoutesConstants.PASSWORD_RECOVERY]: t('routes.passwordRecovery'),
    [RoutesConstants.UNAUTHORIZED]: t('routes.unauthorized'),
    
    [RoutesConstants.NEW_APPOINTMENT]: t('routes.newAppointment'),
    [RoutesConstants.NEW_DOCTOR]: t('routes.newDoctor'),
    [RoutesConstants.NEW_NURSE]: t('routes.newNurse'),
    [RoutesConstants.NEW_OFFICE_VISIT]: t('routes.newOfficeVisit'),
    [RoutesConstants.NEW_PATIENT]: t('routes.newPatient'),
    [RoutesConstants.NEW_PROVIDER]: t('routes.newProvider'),
    [RoutesConstants.NEW_USER]: t('routes.newUser'),
    
    [RoutesConstants.USER_AUTH_LOGIN]: t('routes.userLogin'),
    [RoutesConstants.USER_AUTH_VALIDATE]: t('routes.userValidation'),
    [RoutesConstants.USER_AUTH_CODE]: t('routes.userCode'),
    [RoutesConstants.USER_ID]: t('routes.userId'),
    
    [RoutesConstants.HOME]: t('routes.home'),
    
    [RoutesConstants.EDIT_DOCTOR]: t('routes.editDoctor'),
    [RoutesConstants.EDIT_NURSE]: t('routes.editNurse'),
    [RoutesConstants.EDIT_PATIENT]: t('routes.editPatient'),

    [RoutesConstants.VIDEOCHAT_GUEST_CODE]: t('routes.videochatGuest'),
    [RoutesConstants.CLAIM]: t('routes.claim'),
    [RoutesConstants.ASSET_VIEWER]: t('routes.assetViewer'),
     
});